module.exports = __webpack_public_path__ + "img/new_row_code.e5433f79.png";